import React from 'react';
import useUserStore from 'store/useUserStore';
import { usePermissions } from 'access/usePermission';
import BagelChatWidget from './components/BagelChatWidget/BagelChatWidget';

/**
 * Renders the floating BagelChatWidget only when:
 * 1. A user is logged in (prevents flash before auth redirect)
 * 2. The user has the 'bagel:chat' permission
 *
 * This component lives outside all routes so the widget persists across navigation.
 */
export default function BagelChatGate() {
  const user = useUserStore(s => s.user);
  const { can } = usePermissions();

  if (!user) return null;
  if (!can('bagel:chat')) return null;

  return <BagelChatWidget />;
}
